<template>
  <custom-callout class="callout mt-2" :has-border="false" :has-toggle="true">
    <div class="row mt-2 row-container py-4">
      <div class="col-md-2 col-12 border-right status">
        <div class="row">
          <div class="col-12">
            <div class="label">Número:</div>
            <span class="info font-weight-bold">
              {{ value.separationFundNumber }}
            </span>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-10">
        <div class="row">
          <div class="col-12 col-md-4">
            <div class="label">Contratación:</div>
            <span class="info">
              {{ value.contractTypeName }}
            </span>
          </div>
          <div class="col-12 col-md-3">
            <div class="label">Fecha Hasta:</div>
            <span class="info">
              {{ value.contractDateTo | date }}
            </span>
          </div>
          <div class="col-12 col-md-3">
            <div class="label">Monto:</div>
            <span class="info">
              {{ value.cost | price }}
            </span>
          </div>
          <div class="col-12 col-md-2">
            <dropdown
              v-if="showSeparationFundsReportsButton"
              class="actions-dropdown"
              :items="actionsDropdown"
              responsive
              title="Acciones"
            />
          </div>
        </div>
      </div>
    </div>
    <template #edition>
      <div class="mx-2 mx-md-4 mx-3">
        <div class="bg-white border-radius--light py-2 px-4">
          <div class="row">
            <div class="col-12 mb-3">
              <em class="fas fa-info-circle text-orange mr-1" />
              <span>Información Adicional</span>
            </div>
            <div class="col-12 mb-4">
              <div class="label">Justificación:</div>
              <span class="info">
                {{ value.justification }}
              </span>
            </div>
            <div class="col-12">
              <custom-separator
                class="separation-of-funds__separator my-4"
                text="Cifra de Cuenta"
              />
              <account-number
                v-for="accountNumber of value.accountNumbers"
                :key="`accountNumber-${accountNumber.purchaseOrderNumberId}`"
                bg-color="bg-secondary-3"
                :can-remove="false"
                class="mb-3"
                :is-read-only="true"
                :value="accountNumber"
              />
            </div>
          </div>
        </div>
      </div>
    </template>
  </custom-callout>
</template>

<script>
import CustomCallout from 'custom-callout';
import CustomSeparator from 'custom-separator';

import AccountNumber from '@/views/provider/proposalHistory/components/AccountNumberV2.vue';
import Dropdown from 'dropdown';

import {
  getSeparationFundsReport,
  getCertifiedAvailabilitySFReport,
} from '@/modules/serviceProposalHistory/api';

import _generalApi from '@/modules/app/api';
import proposalStatus from '@/utils/shared/constants/proposalStatus';

export default {
  components: { CustomCallout, CustomSeparator, AccountNumber, Dropdown },
  props: {
    proposalRequestId: {
      type: Number,
      default: () => null,
    },
    proposalStatusId: {
      type: Number,
      default: () => null,
    },
    value: {
      type: Object,
      default: () => ({}),
    },
    isContractSigned: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    inContract() {
      return this.$route.params.contractId;
    },
    canEdit() {
      return (
        (!this.inContract ||
          (this.inContract == this.value.contractId &&
            !this.isContractSigned)) &&
        this.proposalStatusId <= proposalStatus.FundsSeparation &&
        this.userHasPermissions('provider.proposal.separationFunds.edit')
      );
    },
    actionsDropdown() {
      return [
        {
          name: 'edit',
          label: 'Editar',
          icon: 'fas fa-edit text-green pr-1',
          visible: this.canEdit,
          click: () => {
            this.$emit('on-edit', this.value.separationFundNumber);
          },
        },
        {
          name: 'fundsReport',
          label: 'Separación de Fondos',
          icon: 'fas fa-download text-green pr-1',
          visible: true,
          click: () => this.SeparationFundsReport(),
        },
        {
          name: 'availabilityReport',
          label: 'Certificación de Disponibilidad de Fondos',
          icon: 'fas fa-download text-green pr-1',
          visible: true,
          click: () => this.CertifiedAvailabilitySFReport(),
        },
      ];
    },
    showSeparationFundsReportsButton() {
      return this.userHasPermissions('proposal.administrator');
    },
  },
  methods: {
    async SeparationFundsReport() {
      return await getSeparationFundsReport({
        proposalRequestId: this.proposalRequestId,
        contractId: this.value.contractId,
        number: this.value.separationFundNumber,
      }).then((res) => _generalApi.ConvertToBlob(res.data));
    },
    async CertifiedAvailabilitySFReport() {
      return await getCertifiedAvailabilitySFReport({
        proposalRequestId: this.proposalRequestId,
        contractId: this.value.contractId,
        number: this.value.separationFundNumber,
      }).then((res) => _generalApi.ConvertToBlob(res.data));
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/shared/scss/config/colors.scss';

.label {
  font-weight: normal;
  font-size: 0.875rem;
  color: map-get($colors, 'secondary-6');
}

.info {
  font-weight: normal;
  color: map-get($colors, 'black');
}
.separation-of-funds__separator ::v-deep {
  .separator-custom {
    --background-color-active: #b5c3bc;
    --line-separator-color: #b5c3bc;
    font-size: 0.875rem;
  }
}
</style>
